// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_CategoryFacet.scss
// module id = 552
// module chunks = 1 4 5 6 7 88